import { useState, useEffect } from "react";

interface NavBarProps {
  onNavigate: (id: string) => void;
}

const navLinks = [
  { label: "Collection", id: "collection" },
  { label: "Story", id: "editorial" },
  { label: "Custom", id: "custom" },
  { label: "Contact", id: "footer" },
];

export default function NavBar({ onNavigate }: NavBarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-700 ${
        scrolled ? "bg-[#FAF8F3]/95 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-10 py-5 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => onNavigate("hero")}
          className="cursor-pointer flex items-center gap-3"
        >
        </button>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button
                onClick={() => onNavigate(link.id)}
                className={`text-xs uppercase tracking-[3px] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap relative group ${
                  scrolled ? "text-[#6B4423]" : "text-[#FAF8F3]"
                }`}
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                {link.label}
                <span
                  className={`absolute -bottom-0.5 left-0 w-0 h-px group-hover:w-full transition-all duration-300 ${
                    scrolled ? "bg-[#B76E79]" : "bg-[#D4AF87]"
                  }`}
                />
              </button>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <button
          onClick={() => onNavigate("collection")}
          className={`hidden md:block text-xs uppercase tracking-[2px] px-7 py-3 border transition-all duration-300 cursor-pointer whitespace-nowrap ${
            scrolled
              ? "border-[#B76E79] text-[#B76E79] hover:bg-[#B76E79] hover:text-white"
              : "border-[#D4AF87]/70 text-[#D4AF87] hover:bg-[#D4AF87]/20"
          }`}
          style={{ fontFamily: "Inter, sans-serif", borderRadius: "2px" }}
        >
          Explore Collection
        </button>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden w-6 h-6 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-[#6B4423]" : "text-[#FAF8F3]"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#FAF8F3]/98 backdrop-blur-sm transition-all duration-500 overflow-hidden ${
          menuOpen ? "max-h-80 py-6" : "max-h-0"
        }`}
      >
        <ul className="flex flex-col items-center gap-6 px-10">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button
                onClick={() => { onNavigate(link.id); setMenuOpen(false); }}
                className="text-xs uppercase tracking-[3px] text-[#6B4423] cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
